<template>
	<div
		:class="{disabled: disabled}"
		class="edge-lines tooltip tooltip--centered-m dark"
	>
		<div class="edge-lines__instance">
			<div class="edge-lines__title field-label mb--10">{{ t('sidebar.edgeDesign.label.lineStart') }}</div>
			<div class="edge-lines__list flipped">
				<div
					v-for="(line, $indexLine) in EDGE_LINES"
					:key="`flipped-${$indexLine}`"
					:class="{active: start === line.VALUE}"
					class="edge-lines__item"
					@click="chooseStart(line.VALUE)"
				>
					<i v-if="line.ICON" :class="line.ICON"></i>
					<template v-else>none</template>
				</div>
			</div>
		</div>
		<i
			@click="toggleLines"
			:class="[toggleLineTransitionClassname, toggleLineRotateClassname]"
			class="fas fa-sync fs--15 color--black cursor--pointer"></i>
		<div class="edge-lines__instance">
			<div class="edge-lines__title flex--justify-end field-label mr--none mb--10">{{ t('sidebar.edgeDesign.label.lineEnd') }}</div>
			<div class="edge-lines__list right">
				<div
					v-for="(line, $indexLine) in EDGE_LINES"
					:key="$indexLine"
					:class="{active: end === line.VALUE}"
					class="edge-lines__item"
					@click="chooseEnd(line.VALUE)"
				>
					<i v-if="line.ICON" :class="line.ICON"></i>
					<template v-else>none</template>
				</div>
			</div>
		</div>
		<div v-if="disabled" class="tooltip__item bottom">{{ t('common.soon') }}</div>
	</div>
	<div class="field-row">
		<field-regular
			:label="t('quickEditBar.size')"
			:label-inline="true"
			:field-classname="'field--w-50'"
			:numbers-only="true"
			:unit="'%'"
			v-model:model-value="lineStartSize"
			:disabled="start === 'none'"
		></field-regular>
		<field-regular
			:label="t('quickEditBar.size')"
			:label-inline="true"
			:field-classname="'field--w-50'"
			:numbers-only="true"
			:field-item-classname="'flex--justify-end'"
			:unit="'%'"
			v-model:model-value="lineEndSize"
			:disabled="end === 'none'"
		></field-regular>
	</div>
</template>

<script>
import { EDGE_LINES } from '@/modules/Edge';
import {computed, nextTick, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import FieldRegular from '@/components/fields/FieldRegular';
export default {
	components: {
		FieldRegular,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		start: {
			type: String,
			default: EDGE_LINES.NONE.VALUE
		},
		startSize: {
			type: [Number, Object],
			default: 100
		},
		end: {
			type: String,
			default: EDGE_LINES.NONE.VALUE
		},
		endSize: {
			type: [Number, Object],
			default: 100
		}
	},
	emits: ["update:start", "update:startSize", "update:end", "update:endSize"],
	setup(props, {emit}) {
		const {t} = useI18n();
		const toggleLineTransitionClassname = ref('');
		const toggleLineRotateClassname = ref('');
		
		const lineStartSize = computed({
			get(){return props.startSize},
			set(value){
				emit('update:startSize', value);
			}
		})
		const lineEndSize = computed({
			get(){return props.endSize},
			set(value){
				emit('update:endSize', value);
			}
		})
		
		function chooseStart(value){
			if(props.disabled) return;
			emit("update:start", value)
		}
		function chooseEnd(value){
			if(props.disabled) return;
			emit("update:end", value)
		}
		function toggleLines(){
			if(props.disabled) return;
			rotateIcon();
			emit("update:start", props.end);
			emit("update:end", props.start);
			// replace start and end sizes by each other
			const startSize = lineStartSize.value;
			const endSize = lineEndSize.value;
			emit("update:startSize", endSize);
			emit("update:endSize", startSize);
			setTimeout(() => {
				rotateIcon();
			}, 300)
		}
		function rotateIcon(){
			if (!toggleLineTransitionClassname.value) {
				toggleLineTransitionClassname.value = 'transition'
				nextTick(()=> {
					toggleLineRotateClassname.value = 'rotate'
				})
			} else {
				toggleLineTransitionClassname.value = '';
				nextTick(() => {
					toggleLineRotateClassname.value = ''
				})
			}
		}
		
		return {
			t,
			EDGE_LINES,
			chooseStart,
			chooseEnd,
			toggleLines,
			toggleLineTransitionClassname, toggleLineRotateClassname,
			lineStartSize,
			lineEndSize
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/elements/custom/edge-lines-variables" as *;
@use "@/scss/sections/editor/elements/custom/edge-lines";
@use "@/scss/sections/editor/elements/shapes/shape-icons";
</style>
